import { DamState } from "./dam-state.interface";

export function createDamState(): DamState {
  return {
    signature: null,
    signatureFetchedAt: null,
    isLoading: false,
  };
}
